// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__czvuO","footer":"styles_footer__1xOX3"};